angular.module('study.ecrd.queries', [
    'ecrd',
    'ecrd.queries',
    'gettext',
    'inetsys.messages',
    'inetsys.modal',
    'route',
    'sharecrf-sdk',
    'table-settings',
]);
